module.exports = __webpack_public_path__ + "static/media/andiamo.fb1e73a3.gif";